module.exports = __webpack_public_path__ + "static/media/IconTemplates_-71.2fdba3b7.svg";